import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { InMemoryCacheService } from 'src/app/common';
import { Router } from '@angular/router';
@Component({
  selector: 'app-404',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule],
  template: ``,
//   templateUrl: './404.component.html',
})
export class App404Component implements OnInit {

  private cache = inject(InMemoryCacheService);
  private router = inject(Router);
  currentPlans: any[] = [];

  public isLoaded: boolean | null = null;

  async ngOnInit() {
    this.isLoaded = false;
    this.cache.loading = true;
    const claims = await this.cache.getClaims();
    this.currentPlans = claims?.data?.filter(c => c?.type === 'Plan') ?? [];
    this.manageRedirectUrl();
    this.isLoaded = true;
    this.cache.loading = false;
  }

  private manageRedirectUrl(){
    if(this.hasSeoPlan) {
       this.router.navigate(['/dashboard']);
    }
    else if(this.hasDbcPlan){
       this.router.navigate(['/dbc']);
    }
    else if(this.hasAskKevinPlan){
        this.router.navigate(['/askkevin/chatbot']);
    }
    else {
        this.router.navigate(['/billing/subscription']);
    }
  }

  // Consolidate common logic into a reusable helper
  private hasPlan(planType: string): boolean {
    return this.currentPlans.some(p => p?.value === planType);
  }

  // Readable computed getters
  get hasSeoPlan(): boolean {
    return this.hasPlan('seoPlan');
  }

  get hasAskKevinPlan(): boolean {
    return this.hasPlan('askKevinPlan');
  }

  get hasDbcPlan(): boolean {
    return this.hasPlan('businessCardPlan');
  }

}
